var f = Object.defineProperty;
var y = (a, t, e) => t in a ? f(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var o = (a, t, e) => (y(a, typeof t != "symbol" ? t + "" : t, e), e);
import { computed as U, openBlock as u, createElementBlock as h, Fragment as b, renderList as x, unref as w, createCommentVNode as R, createElementVNode as v, normalizeClass as k } from "vue";
var l = { DMP: "cdn2.webdamdb.com", UA: "urbanarrow-res.cloudinary.com", CLOUDINARY: "res.cloudinary.com", SVG: "cdn1-originals.webdamdb.com" }, m = "resource.pon.bike", T = class d {
  constructor(t, e = [], r = null) {
    o(this, "url");
    o(this, "transformations");
    this.url = new URL(t), this.transformations = e, this.extension = r, this.isOldResourceUrl && (this.cleanUpOldUrl(), this.url.hostname = m), this.needsConvert && (this.convertToResourceUrl(), this.url.hostname = m), this.needsTransformations && this.isResourceUrl && this.addTransformations(), this.needsExtension && this.isResourceUrl && this.changeExtension(), this.isResourceUrl && this.url.protocol === "http:" && (this.url.protocol = "https");
  }
  get needsConvert() {
    return Object.values(l).includes(this.url.hostname);
  }
  get needsTransformations() {
    return this.transformations.length > 0;
  }
  get needsExtension() {
    return this.extension;
  }
  get isResourceUrl() {
    return this.url.hostname === m;
  }
  get isOldResourceUrl() {
    return this.url.hostname === "cloudinary.pondigital.solutions";
  }
  get bucket() {
    let t = this.url.pathname.substring(1, this.url.pathname.indexOf("/", 1));
    return t === "image" ? this.url.hostname.split(".")[0].replace("-res", "") : t;
  }
  cleanUpOldUrl() {
    this.url.pathname = this.url.pathname.replace("/pon-digital-solutions/image/upload/", "/dmp/").replace("/dmp.pon.bike/", "/");
  }
  changeExtension() {
    let t = this.url.pathname.substring(0, this.url.pathname.lastIndexOf("."));
    this.url.pathname = `${t}.${this.extension}`;
  }
  addTransformations() {
    let t = this.url.pathname.split("/").filter((r) => r), e = t.shift();
    this.url.pathname = ["", e, this.transformations.filter((r) => r.length).map((r) => r.join(",")).join("/"), ...t].join("/");
  }
  convertToResourceUrl() {
    if (this.url.hostname === l.DMP && (this.url.pathname = `/dmp${this.url.pathname}`), this.url.hostname === l.SVG && (this.url.pathname = `/svg-kf${this.url.pathname}`), this.url.hostname === l.UA || this.url.hostname === l.CLOUDINARY) {
      let { bucket: t } = this;
      t === "urbanarrow-staging" && (this.url.pathname = this.url.pathname.replace(/^\/urbanarrow-staging/, "/ua-stg")), t === "urbanarrow" && (this.url.pathname = this.url.pathname.replace(/^\/urbanarrow/, "/ua").replace(/^\/image/, "/ua/image"));
    }
  }
  toString() {
    return this.isResourceUrl ? this.url.toString() : null;
  }
  static transform(t, e = [], r = null) {
    return new d(t, e, r).toString();
  }
}, p = T;
const S = ["media", "srcset", "type"], O = ["alt", "src"], j = {
  __name: "PictureElement",
  props: {
    highResUrl: {
      type: String,
      required: !0
    },
    altText: {
      type: String,
      required: !0
    },
    defaultImage: {
      type: String,
      default: "https://archive.org/download/placeholder-image/placeholder-image.jpg"
    },
    extensions: {
      type: Array,
      default: ["avif", "webp", "jpeg"]
    },
    medias: {
      type: Array,
      default: [
        { minWidth: 600, imgWidth: 500 },
        { minWidth: 300, imgWidth: 200 },
        { minWidth: 1, imgWidth: 50 }
      ]
    },
    unit: {
      type: String,
      default: "px"
    },
    imgClass: {
      type: String,
      default: ""
    },
    extraTransformations: {
      type: Array,
      default: [[]]
    }
  },
  setup(a) {
    const t = a, e = U(() => {
      try {
        return p.transform(t.highResUrl);
      } catch {
        return !1;
      }
    }), r = t.medias.map((i) => t.extensions.map((s) => ({
      media: `(min-width: ${i.minWidth}${t.unit})`,
      url: c(s, i.imgWidth),
      type: g(s)
    }))).flat();
    function g(i) {
      let s = "";
      switch (i) {
        case "webp":
          s = "image/webp";
          break;
        case "avif":
          s = "image/avif";
          break;
        default:
          s = "image/jpeg";
          break;
      }
      return s;
    }
    function c(i = "png", s = 150) {
      try {
        const n = [...t.extraTransformations];
        return n.push([`w_${s}`]), p.transform(t.highResUrl, n, i) || t.defaultImage;
      } catch (n) {
        console.error(n);
      }
      return t.defaultImage;
    }
    return (i, s) => (u(), h("picture", null, [
      e.value ? (u(!0), h(b, { key: 0 }, x(w(r), (n) => (u(), h("source", {
        media: n.media,
        srcset: n.url,
        type: n.type
      }, null, 8, S))), 256)) : R("", !0),
      v("img", {
        alt: a.altText,
        src: c(),
        class: k(a.imgClass)
      }, null, 10, O)
    ]));
  }
};
export {
  j as PictureElement
};
